import { render } from "./ProductsListProductDescription.vue?vue&type=template&id=a0f47b80"
import script from "./ProductsListProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductsListProductDescription.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__